import { jsx as _jsx } from "react/jsx-runtime";
import { Checkbox, Radio, getTestId } from '@airtel/air-design-system';
import { Fragment } from 'react';
import { getFilterItemStyles } from './FilterItemStyles';
export var FilterItem = props => {
  var _props$testID = props.testID,
    testID = _props$testID === void 0 ? 'FilterItem' : _props$testID,
    style = props.style,
    item = props.item,
    index = props.index,
    onFilterItemPress = props.onFilterItemPress,
    type = props.type;
  var Component = type === 'single' ? Radio : Checkbox;
  var filterItemStyles = getFilterItemStyles();
  return _jsx(Fragment, {
    children: _jsx(Component, Object.assign({}, getTestId(testID), {
      label: item === null || item === void 0 ? void 0 : item.name,
      labelPosition: "left",
      value: item === null || item === void 0 ? void 0 : item.name,
      disabled: item === null || item === void 0 ? void 0 : item.isDisabled,
      isBoldLabel: item === null || item === void 0 ? void 0 : item.isBoldLabel,
      checked: item === null || item === void 0 ? void 0 : item.checked,
      onPress: () => onFilterItemPress(item),
      style: [style, filterItemStyles === null || filterItemStyles === void 0 ? void 0 : filterItemStyles.itemStyle]
    }))
  }, (item === null || item === void 0 ? void 0 : item.name) + index);
};